import React, { useState } from "react";
import { Toaster } from "react-hot-toast";
import Sidebar from "./components/Sidebar";
import ChatPage from "./pages/ChatPage";
import ComparePage from "./pages/ComparePage";
import SearchPage from "./pages/SearchPage";
import DocumentMapPage from "./pages/DocumentMapPage";
import "./index.css";

export default function App() {
  const [activeTab, setActiveTab] = useState("chat");
  const [documents, setDocuments] = useState([]);
  const [systemStatus, setSystemStatus] = useState(null);
  const [chatState, setChatState] = useState({ messages: [], input: "", searchMode: "hybrid", selectedDocs: null, chats: [], activeChatId: null });
  const [compareState, setCompareState] = useState({ query: "", selectedDocs: [], result: null });
  const [mapState, setMapState] = useState({ mapData: null, error: null });

  const TABS = [
    { id: "chat", label: "Chat" },
    { id: "compare", label: "Compare Docs" },
    { id: "search", label: "Search" },
    { id: "map", label: "Document Map" },
  ];

  return (
    <div style={{ display: "flex", height: "100vh", background: "var(--bg)", overflow: "hidden" }}>
      <Toaster position="top-right" toastOptions={{
        style: { background: "var(--surface)", color: "var(--text-1)", border: "1px solid var(--border)", borderRadius: "10px", fontSize: "13px" }
      }} />

      <Sidebar documents={documents} setDocuments={setDocuments} systemStatus={systemStatus} setSystemStatus={setSystemStatus} />

      <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
        {/* Header — pill tabs */}
        <header style={{ display: "flex", alignItems: "center", gap: "2px", padding: "8px 16px", borderBottom: "1px solid var(--border)", background: "var(--bg)", flexShrink: 0 }}>
          {TABS.map(tab => (
            <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`pill-tab ${activeTab === tab.id ? "active" : ""}`}>
              {tab.label}
            </button>
          ))}
          <div style={{ flex: 1 }} />
          <div style={{ display: "flex", alignItems: "center", gap: "6px", fontSize: "12px", color: "var(--text-2)" }}>
            <span style={{ width: "7px", height: "7px", borderRadius: "50%", background: systemStatus?.embedding_model ? "var(--accent)" : "#f59e0b", display: "inline-block" }} />
            {systemStatus?.embedding_model ? "Models ready" : "Loading models..."}
          </div>
        </header>

        <main style={{ flex: 1, overflow: "hidden" }}>
          {activeTab === "chat" && <ChatPage documents={documents} chatState={chatState} setChatState={setChatState} />}
          {activeTab === "compare" && <ComparePage documents={documents} compareState={compareState} setCompareState={setCompareState} />}
          {activeTab === "search" && <SearchPage documents={documents} />}
          {activeTab === "map" && <DocumentMapPage documents={documents} mapState={mapState} setMapState={setMapState} />}
        </main>
      </div>
    </div>
  );
}